import React from 'react'

import { StyleSheet, Text } from '@react-pdf/renderer'
import PropTypes from "prop-types"

const styles = StyleSheet.create({
  variableContent: {
    color: 'black',
  },
})

const DataUnavailableText = ({ text }) => {
  return (
    <Text style={styles.variableContent}>
      {text || 'Nenhum registro encontrado.'}
    </Text>
  )
}

DataUnavailableText.propTypes = {
  text: PropTypes.string,
}

DataUnavailableText.defaultProps = {
  text: null,
}
export default DataUnavailableText
